<section id="services" class="services-section">
  <div class="container">

    <!-- Header Section -->
    <div class="row" appAnimateOnScroll="fade-in-up">
      <div class="col-12 text-center mb-5">
        <h2 class="services-title">
          <span class="text-accent">{{ 'services.TITLE' | translate }}</span>{{ 'services.SUBTITLE' | translate }}
        </h2>
        <p class="services-description">
          {{ 'services.MAIN_DESCRIPTION' | translate }}
        </p>
      </div>
    </div>

    <!-- Discovery Service (Large Card) -->
    <div class="row mb-5" appAnimateOnScroll="fade-in-up">
      <div class="col-12">
        <div class="service-card service-card-large">
          <div class="row h-100 g-0">
            <div class="col-md-6 d-flex flex-column justify-content-center p-4 p-md-5">
              <span class="service-label">Discovery</span>
              <h3 class="service-title">{{ services[0].title | translate }}</h3>
              <p class="service-description">{{ services[0].description | translate }}</p>
            </div>
            <div class="col-md-6 service-image-container">
              <img [src]="services[0].image"
                [alt]="services[0].title | translate">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- UX/UI and Apps Services (Small Cards) -->
      <div class="row align-items-stretch">
        @for (service of services.slice(1); track service; let i = $index) {
          <div class="col-md-6 mb-4" appAnimateOnScroll="fade-in-up" [style.transition-delay.ms]="i * 150">
            <div class="service-card service-card-small h-100">
              <div class="card-header">
                <span class="service-label">{{ service.type | uppercase }}</span>
                <h4 class="service-title">{{ service.title | translate }}</h4>
              </div>
              <div class="card-body flex-grow-1">
                <p class="service-description">{{ service.description | translate }}</p>
              </div>
              <div class="card-footer">
                <img [src]="service.image"
                  [alt]="service.title | translate"
                  class="service-image-small">
                </div>
              </div>
            </div>
          }
        </div>

      </div>
    </section>